"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameLoaderBase = void 0;
const dynamicLoad_1 = require("../../dynamicLoad");
const mobileConnector_1 = require("../../mobileConnector");
const initializer_1 = require("../../initializer");
const initializer_2 = require("../../initializer");
const frameBaseLoaderCommon_1 = require("../frameBaseLoaderCommon");
const frameLoaderBase = async (params) => {
    if (await (0, mobileConnector_1.initMobileCommunicator)(initializer_2.Session, params.mobileConnectorConfig)) {
        await initializer_1.HybridAuthenticator.login();
    }
    (0, frameBaseLoaderCommon_1.frameLoaderBaseCommon)(params, dynamicLoad_1.Router, dynamicLoad_1.Routes);
};
exports.frameLoaderBase = frameLoaderBase;
//# sourceMappingURL=index.js.map